import jsPDF from 'jspdf';
import type { ClassificationObservation } from './types';

export interface ClassificationReportDetails {
  studentName: string;
  observations: ClassificationObservation[];
  conclusion: string;
  keyTitle?: string;
  mode: string;
}

export function generateClassificationReport({ studentName, observations, conclusion, keyTitle, mode }: ClassificationReportDetails): Blob {
  const pdf = new jsPDF();
  const pageHeight = pdf.internal.pageSize.getHeight();
  let y = 18;
  const write = (text: string, size = 10) => {
    pdf.setFontSize(size);
    const lines = pdf.splitTextToSize(text, 180) as string[];
    if (y + lines.length * 6 > pageHeight - 16) { pdf.addPage(); y = 18; }
    pdf.text(lines, 14, y);
    y += lines.length * 6 + 2;
  };
  pdf.setTextColor(37, 72, 57);
  write('Classification of Living Organisms Laboratory Report', 17);
  pdf.setTextColor(35, 45, 42);
  write(`Student: ${studentName || 'Student'}    Date: ${new Date().toLocaleDateString()}`);
  write(`Mode: ${mode.replaceAll('-', ' ')}${keyTitle ? `    Key: ${keyTitle}` : ''}`);
  write('Aim: Observe diagnostic characteristics and classify organisms using evidence and a dichotomous key.');
  write(`Specimens recorded: ${observations.length}`);
  observations.forEach((item, index) => {
    pdf.setFont('helvetica', 'bold');
    write(`${index + 1}. ${item.commonName} — ${item.scientificName}`, 11);
    pdf.setFont('helvetica', 'normal');
    write(`Tool: ${item.tool.replaceAll('-', ' ')}. Features: ${item.featuresObserved.join(', ') || 'none recorded'}.`);
    write(`Key decisions: ${item.keyDecisions.join(' → ') || 'not recorded'}.`);
    write(`Classification: ${item.domain} / ${item.kingdom} / ${item.phylumOrDivision} / ${item.className} / ${item.order} / ${item.family} / ${item.genus} / ${item.species}.`);
    if (item.sketchDataUrl) {
      try { if (y + 55 > pageHeight - 16) { pdf.addPage(); y = 18; } pdf.addImage(item.sketchDataUrl, 'PNG', 14, y, 70, 35); y += 39; } catch (error) { write('A sketch was recorded but could not be embedded in this report.'); }
    }
    write(`Remarks: ${item.remarks || 'None'}`);
  });
  pdf.setFont('helvetica', 'bold');
  write('Conclusion and discussion', 12);
  pdf.setFont('helvetica', 'normal');
  write(conclusion || 'No conclusion recorded.');
  const blob = pdf.output('blob');
  pdf.save('classification-lab-report.pdf');
  return blob;
}
